import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Note = styled.span`
  background-color: ${props => props.theme.palette.primary.alpha};
  display: block;
  padding: 30px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 20px;
  border: 1px dotted ${props => props.theme.palette.primary.alphaDark};
`

export const Container = styled.div<{ isUpdating?: boolean }>`
  position: relative;
  z-index: 1;
  ${props => props.isUpdating && `
    &::before {
      content: ' ';
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: wait;
      opacity: 0.5;
      background: #fff;
    }
  `}

  .cards {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    .card {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      font-size: 14px;
      margin: 0 30px 0 0;
      border: 1px solid ${props => props.theme.palette.general.greyLight};
      ${bp('sm')`
        width: calc(100% - 40px);
        margin: 0 auto 20px;
      `}

      &.default {
        border-color: ${props => props.theme.palette.primary.alpha};
      }

      .address {
        p {
          margin: 0;

          &:nth-child(1) {
            margin-bottom: 1em;
          }
        }
      }

      .actions {
        box-sizing: border-box;
        text-align: right;

        button {
          height: 30px;
          margin-left: 15px;

          &[disabled] {
            background: none;
            opacity: 1;
          }

          > div {
            color: ${props => props.theme.palette.primary.alphaDark};
            font-weight: 600;

            :hover {
              color: ${props => props.theme.palette.primary.alpha};
            }
          }
        }
      }
    }

    .new-card {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
  }
`
